<template>
    <ui-section title="Importações de lista de credores" description="Planilhas importadas para os QGCs deste caso." flush>
        <template #actions>
            <v-btn v-if="$allowed('create')" color="primary" depressed small @click="importList">
                <v-icon left small>mdi-file-upload-outline</v-icon>
                Importar lista de credores
            </v-btn>
        </template>
        <v-data-table :headers="headers" :items="items" :loading="loading" disable-sort hide-default-footer :items-per-page="-1"
            no-data-text="Nenhuma lista importada neste caso" loading-text="Carregando importações..." class="ui-clickable-rows" @click:row="open">
            <template v-slot:[`item.name`]="{ item }">
                <span class="ui-cell-main">{{ item.name }}</span>
                <div v-if="item.client_company" class="ui-cell-sub">{{ item.client_company.name }}</div>
            </template>
            <template v-slot:[`item.version`]="{ item }">{{ versionLabel(item.version) }}</template>
            <template v-slot:[`item.status`]="{ item }">
                <ui-badge :text="statusLabel(item.status)" :color="statusColor(item.status)" />
            </template>
            <template v-slot:[`item.lines`]="{ item }">{{ item.current_line || 0 }} / {{ item.total_lines || 0 }}</template>
            <template v-slot:[`item.created_at`]="{ item }">{{ item.created_at | defaultDate("DD/MM/YYYY") }}</template>
            <template v-slot:[`item.actions`]="{ item }">
                <ui-row-actions :actions="[
                    { text: 'Ver importação', icon: 'mdi-eye-outline', handler: () => open(item) },
                    {
                        text: 'Remover lista e créditos importados',
                        icon: 'mdi-delete-outline',
                        danger: true,
                        disabled: Number(item.status) !== 1 || !$check('Creditors', 'DELETE'),
                        handler: () => remove(item),
                    },
                ]" />
            </template>
        </v-data-table>

        <creditor-list-remove-dialog v-model="removeDialog" :list="listToRemove" @removed="onRemoved" />
    </ui-section>
</template>

<script>
import axios from "axios";
import creditorListStatus from "@/common/data/creditor-list-status.data";
import CreditorListRemoveDialog from "@/components/CreditorListRemoveDialog.vue";

// QGC: listas de credores importadas para o caso (antes, tela propria "Lista de Credores").
export default {
    name: "CreditorListImports",

    components: { CreditorListRemoveDialog },

    props: {
        clientId: { type: [Number, String], required: true },
        // Versao da aba aberta no QGC: vira o destino padrao da proxima importacao.
        version: { type: [Number, String], default: null },
        // QGCs do caso (para o nome da versao de cada lista).
        versions: { type: Array, default: () => [] },
    },

    data: () => ({
        items: [],
        loading: false,
        removeDialog: false,
        listToRemove: null,
        headers: [
            { text: "Lista", value: "name" },
            { text: "QGC de destino", value: "version" },
            { text: "Situação", value: "status" },
            { text: "Linhas", value: "lines" },
            { text: "Enviada em", value: "created_at" },
            { text: "", value: "actions", align: "end", width: 60 },
        ],
    }),

    watch: {
        clientId: { immediate: true, handler() { this.load(); } },
    },

    methods: {
        async load() {
            if (!this.clientId) return;
            this.loading = true;
            try {
                const response = await axios.get("/api/admin/creditor-lists", {
                    params: { page: 1, limit: 1000, search: JSON.stringify({ client_id: this.clientId }) },
                });
                this.items = (response.data.content && response.data.content.data) || [];
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },

        open(item) {
            this.$router.push(`/lista-credores/${item.id}`);
        },

        remove(item) {
            this.listToRemove = { id: item.id, name: item.name };
            this.removeDialog = true;
        },

        onRemoved() {
            this.load();
            this.$emit("changed");
        },

        importList() {
            const query = { client_id: this.clientId, from: "qgc" };
            if (this.version) query.version = this.version;
            this.$router.push({ path: "/lista-credores/incluir", query });
        },

        versionLabel(version) {
            const number = Number(version) || 1;
            const found = this.versions.find((item) => Number(item.version) === number);
            return found ? `v${number} · ${found.title}` : `v${number}`;
        },

        statusLabel(status) {
            const found = creditorListStatus.find((item) => Number(item.id) === Number(status));
            return found ? found.name : "—";
        },

        statusColor(status) {
            return ({ 0: "warning", 1: "accent", 2: "info", 3: "error" })[Number(status)] || "grey";
        },
    },
};
</script>
